<app-header icon="back" title="_AddNewSpot_" backText="{{backText}}" showNav="false" changed="{{changedVal}}"></app-header>
<div class="body-container add-job-page">
  <app-add-edit-job (changed)="isChanged($event)" mode="create"></app-add-edit-job>
</div>